import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../../helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class CustomShippingData extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [CustomShippingData.delivery_text_attribute_name]: null,
      [CustomShippingData.delivery_days_attribute_name]: []
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getDeliveryTextAttributeName() {
    return CustomShippingData.delivery_text_attribute_name;
  }
  static getDeliveryDaysAttributeName() {
    return CustomShippingData.delivery_days_attribute_name;
  }
  getDeliveryText() {
    return this.getAttribute(CustomShippingData.delivery_text_attribute_name);
  }
  getDeliveryDays() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(CustomShippingData.delivery_days_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
}
_defineProperty(CustomShippingData, "delivery_text_attribute_name", 'delivery_text');
_defineProperty(CustomShippingData, "delivery_days_attribute_name", 'delivery_days');